import { useTranslation } from 'react-i18next'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'
import {
    OreRadioButton,
    OreStack,
    OreText
} from '@edenredespana/oreneta'

export const NewTicketStep1 = (): JSX.Element => {
    const { t } = useTranslation()
    const { caseReasons, form } = useHelpCenter()
    const selectedReasonId = form.watch('caseReasonId')
    const location = useLocation() as { state: { caseReasonId?: number } | null }
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const queryCaseReasonId = searchParams.get('caseReasonId')
        const caseReasonId = location.state?.caseReasonId ?? (
            queryCaseReasonId ? Number(queryCaseReasonId) : undefined
        )
        if (caseReasonId !== undefined) {
            form.setValue('caseReasonId', caseReasonId, { shouldValidate: true })
        }
    }, [location.state, searchParams, form])

    return (
        <OreStack space="medium" placeContent="stretch">
            <OreStack space="xsmall" placeContent="stretch">
                <OreText size="text-lg" bold>{t(HelpCenterTranslations.step1.title)}</OreText>
                <OreText>{t(HelpCenterTranslations.step1.subtitle)}</OreText>
            </OreStack>
            <OreStack space="small" placeContent="stretch">
                {caseReasons?.map((reason) => (
                    <OreRadioButton
                        key={reason.caseReasonId}
                        label={reason.descriptionWeb}
                        name="caseReasonId"
                        value={String(reason.caseReasonId)}
                        checked={selectedReasonId === reason.caseReasonId}
                        onChange={() => form.setValue('caseReasonId', reason.caseReasonId, { shouldValidate: true })}
                    />
                ))}
            </OreStack>
        </OreStack>
    )
}


